import { Grid } from '@mui/material';
import { useMemo } from 'react';
import CrudForm from '../../../../../components/Crud/CrudForm';
import useEntityManager from '../../../../../components/Crud/useEntityManager';
import PrivacyPolitics from '../../../../../components/PrivacyPolitics';
import RFFPassword from '../../../../../components/ReactFinalForms/RFFPassword';
import RFFPhoneField from '../../../../../components/ReactFinalForms/RFFPhoneField';
import RFFTextField from '../../../../../components/ReactFinalForms/RFFTextField';
import LangEnum from '../../../../../lang/LangEnum';
import teceoCrudFormConfig from '../../../../../utils/TeceoCrudFormConfig';
import teceoInputConfig from '../../../../../utils/TeceoInputConfig';
import { firstAccessRepository } from '../../../../profile/firstAccess.repository';
import { useTranslation } from '../../../../translation/TranslationContext';
import { ActivationFormData } from '../../../types/login.types';
import { validateActivationForm } from '../../../util/reviewUserAccount.schema';

interface ActivationLoginFormProps {
  afterSubmit: () => void;
}
const ActivationLoginForm = ({ afterSubmit }: ActivationLoginFormProps) => {
  const { translate } = useTranslation();

  const entityManager = useEntityManager({
    repository: firstAccessRepository(),
  });

  const handleSubmit = async (data: ActivationFormData) => {
    const payloadToSend = {
      name: data.name,
      surname: data.surname,
      email: data.email,
      password: data.password,
      phone: data.phone && data.countryCode ? data.phone.slice(data.countryCode.length) : undefined,
      countryCode: data.countryCode,
    };

    await entityManager.onSubmit(payloadToSend);
  };

  const formInitialItem: ActivationFormData = useMemo(() => {
    const item = entityManager.item;

    if (item?.phone && item.countryCode) {
      return {
        ...entityManager.item,
        phone: `${item.countryCode}${item.phone}`,
      };
    }
    return item;
  }, [entityManager.item]);

  return (
    <CrudForm
      {...teceoCrudFormConfig}
      {...entityManager}
      onSubmit={handleSubmit}
      validate={(values: ActivationFormData) => validateActivationForm(values, translate)}
      afterSubmit={afterSubmit}
      hideGoBack
      item={formInitialItem}
    >
      {({ values }: { values: ActivationFormData }) => (
        <Grid container spacing={2}>
          <Grid size={6}>
            <RFFTextField
              {...teceoInputConfig}
              label={translate(LangEnum.GLOBAL_NAME)}
              name="name"
              disabled={values.isPJ === 'false'}
            />
          </Grid>
          <Grid size={6}>
            <RFFTextField
              {...teceoInputConfig}
              label={translate(LangEnum.GLOBAL_SURNAME)}
              name="surname"
            />
          </Grid>
          <Grid size={12}>
            <RFFPhoneField
              {...teceoInputConfig}
              label={translate(LangEnum.GLOBAL_TELEPHONE)}
              name="phone"
            />
          </Grid>
          <Grid size={12}>
            <RFFTextField
              {...teceoInputConfig}
              size="small"
              label={translate(LangEnum.CREATE_ACCOUNT_FORM_CONFIRM_EMAIL)}
              fullWidth
              name="email"
              type="email"
            />
          </Grid>
          <Grid size={12}>
            <RFFPassword
              {...teceoInputConfig}
              label={translate(LangEnum.PROFILE_USER_FORM_NEW_PASSWORD)}
              name="password"
            />
          </Grid>
          <Grid size={12}>
            <RFFPassword
              {...teceoInputConfig}
              label={translate(LangEnum.CREATE_ACCOUNT_FORM_CONFIRM_PASSWORD)}
              name="confirmPassword"
            />
          </Grid>
          <Grid size={12}>
            <PrivacyPolitics actionLabel={translate(LangEnum.GLOBAL_SAVE)} />
          </Grid>
        </Grid>
      )}
    </CrudForm>
  );
};

export default ActivationLoginForm;
